import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formData: {
    // e.g. name: '', photoId: '', etc.
  },
  currentStep: localStorage.getItem("currentStep") || 2,
  showPopup: false,
  isEditPersonalDetails: false,
  stepStatus: JSON.parse(localStorage.getItem("stepStatus")) || [],
  onboardingCustomer: localStorage.getItem("onboardingCustomer") || null,
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    updateFormData: (state, action) => {
      const { field, value } = action.payload;
      state.formData[field] = value;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    resetFormData: (state) => {
      state.formData = {};
    },
    setCurrentStepRedux: (state, action) => {
      localStorage.setItem("currentStep", action.payload);
      state.currentStep = action.payload;
    },
    setStepStatus: (state, action) => {
      localStorage.setItem("stepStatus", JSON.stringify(action.payload));
      state.stepStatus = action.payload;
    },
    setOnboardingCustomer: (state, action) => {
      localStorage.setItem("onboardingCustomer", action.payload);
      state.onboardingCustomer = action.payload;
    },
    clearOnboardingCustomer: (state) => {
      localStorage.removeItem("onboardingCustomer");
      state.onboardingCustomer = null;
    },
    clearStepStatus: (state) => {
      localStorage.removeItem("stepStatus");
      state.stepStatus = [];
    },
    clearCurrentStep: (state) => {
      localStorage.removeItem("currentStep");
      state.currentStep = 1;
    },
    setShowPopupRedux: (state, action) => {
      // localStorage.setItem("currentStep", action.payload);
      state.showPopup = action.payload;
    },
    clearShowPopupStep: (state) => {
      localStorage.removeItem("currentStep");
      state.showPopup = false;
    },
    setIsEditPersonalDetailsRedux: (state, action) => {
      state.isEditPersonalDetails = action.payload;
    },
    clearIsEditPersonalDetails: (state) => {
      state.isEditPersonalDetails = false;
    },
  },
});

export const {
  updateFormData,
  setFormData,
  resetFormData,
  setCurrentStepRedux,
  clearCurrentStep,
  setShowPopupRedux,
  clearShowPopupStep,
  setIsEditPersonalDetailsRedux,
  clearIsEditPersonalDetails,
  setStepStatus,
  clearStepStatus,
  setOnboardingCustomer,
  clearOnboardingCustomer,
} = formSlice.actions;
export default formSlice.reducer;
